import { cloneDeep } from 'lodash';

export const setDisplay = display => ({
  type: 'SET_DISPLAY',
  display,
});

export const setTemplate = (appId, templateId) => setDisplay({
  appId,
  templateId,
});

export const resetDisplay = () => ({
  type: 'RESET_DISPLAY'
});

// TODO: revisit when implementing notification
export const loadView = view => (dispatch, getState) => {
  const display = cloneDeep(getState().platformInfo.display);
  display.view = view;
  dispatch(setDisplay(display));
};

export const clearView = view => (dispatch, getState) => {
  const display = cloneDeep(getState().platformInfo.display);
  display.view = null;
  dispatch(setDisplay(display));
};


